import tableColumnsDefault from "./tableColumnsDefault.json";
import tableColumnsDatabase from "./tableColumnsDatabase.json";

export const tableColumns = {
  dashboard: tableColumnsDefault,
  returns: tableColumnsDefault,
  database: tableColumnsDatabase,
};
